module.exports = __webpack_public_path__ + "media/images/redesign-images/contract/contract-sales-main-93c488b0375e087c3829aabaf958e5b0.jpg";